import { render } from "./CIS-ResourceCTA.vue?vue&type=template&id=68e5f4c9"
import script from "./CIS-ResourceCTA.vue?vue&type=script&lang=js"
export * from "./CIS-ResourceCTA.vue?vue&type=script&lang=js"

import "./CIS-ResourceCTA.vue?vue&type=style&index=0&id=68e5f4c9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__